/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Title_CsInputs */

const cs_form_title_cs = /** @type {(inputs: Form_Title_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název (CS)`)
};

const en_form_title_cs = /** @type {(inputs: Form_Title_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title (CS)`)
};

/**
* | output |
* | --- |
* | "Title (CS)" |
*
* @param {Form_Title_CsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_title_cs = /** @type {((inputs?: Form_Title_CsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Title_CsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_title_cs(inputs)
	return cs_form_title_cs(inputs)
});